import { render } from "./PaymentRefunds.vue?vue&type=template&id=a0e8f792&ts=true"
import script from "./PaymentRefunds.vue?vue&type=script&lang=ts"
export * from "./PaymentRefunds.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__